import { commitSetter } from '@/utils/vuex';

import service from '@/services/settings';

export default {
  setShopLanguage: commitSetter('setShopLanguage'),
  setShopName: commitSetter('setShopName'),
  setCustomCss: commitSetter('setCustomCss'),
  setShopOwnerName: commitSetter('setShopOwnerName'),
  setReviewRequestEmail: commitSetter('setReviewRequestEmail'),
  setFromEmail: commitSetter('setFromEmail'),
  setNotificationEmail: commitSetter('setNotificationEmail'),
  setReviewPublishing: commitSetter('setReviewPublishing'),
  setImportsAutomaticSync: commitSetter('setImportsAutomaticSync'),
  setAutoReplaceObfuscatedReviewerNames: commitSetter('setAutoReplaceObfuscatedReviewerNames'),
  setImportedReviewAutoApprove: commitSetter('setImportedReviewAutoApprove'),
  setImporterProfiles: commitSetter('setImporterProfiles'),
  setReportsFrequency: commitSetter('setReportsFrequency'),
  setSendReviewRequestsOmnisend: commitSetter('setSendReviewRequestsOmnisend'),
  setSendReviewRequests: commitSetter('setSendReviewRequests'),
  setRequestSequenceAdvancedView: commitSetter('setRequestSequenceAdvancedView'),
  setShowQAndA: commitSetter('setShowQAndA'),
  setAdvancedReviewRequestsEmailTemplateActive: commitSetter(
    'setAdvancedReviewRequestsEmailTemplateActive'
  ),
  setAdvancedCouponEmailTemplateActive: commitSetter('setAdvancedCouponEmailTemplateActive'),
  setAdvancedUnverifiedReviewTemplateActive: commitSetter(
    'setAdvancedUnverifiedReviewTemplateActive'
  ),
  setAdvancedPhotoRequestsEmailTemplateActive: commitSetter(
    'setAdvancedPhotoRequestsEmailTemplateActive'
  ),
  setSendReviewRequestsKlaviyo: commitSetter('setSendReviewRequestsKlaviyo'),
  setSendPhotoRequests: commitSetter('setSendPhotoRequests'),
  setSendPhotoRequestWaitDays: commitSetter('setSendPhotoRequestWaitDays'),
  setPhotoRequestStarSubset: commitSetter('setPhotoRequestStarSubset'),
  setDontSendToRepeatCustomers: commitSetter('setDontSendToRepeatCustomers'),
  setPostPurchaseEmailDays: commitSetter('setPostPurchaseEmailDays'),
  setPostPurchaseEmailDaysInternational: commitSetter('setPostPurchaseEmailDaysInternational'),
  setPostPurchaseEmailDaysPosOrder: commitSetter('setPostPurchaseEmailDaysPosOrder'),
  setResendReviewRequests: commitSetter('setResendReviewRequests'),
  setResendEmailWaitDays: commitSetter('setResendEmailWaitDays'),
  setPostPurchaseEmailSendAtHour: commitSetter('setPostPurchaseEmailSendAtHour'),
  setPostPurchaseEmailSendAtMinute: commitSetter('setPostPurchaseEmailSendAtMinute'),
  setBlacklistedReviewRequestEmails: commitSetter('setBlacklistedReviewRequestEmails'),
  setEmailDomain: commitSetter('setEmailDomain'),
  setEmailSubdomain: commitSetter('setEmailSubdomain'),
  setShowReviewsFromArchivedProducts: commitSetter('setShowReviewsFromArchivedProducts'),
  setDeactivateEmailNotifications: commitSetter('setDeactivateEmailNotifications'),
  setEmailTranslationEnabled: commitSetter('setEmailTranslationEnabled'),
  setSendOnlyReviewRequestsSms: commitSetter('setSendOnlyReviewRequestsSms'),
  setReviewRequestExcludedProducts: commitSetter('setReviewRequestExcludedProducts'),
  validateEmailRecords: ({ commit }) => {
    return service
      .validateEmailRecords()
      .then(response => commit('setEmailRecords', response.data));
  },
  loadSettings: ({ commit }) => {
    return service.getSettings().then(response => commit('loadSettingsSuccess', response));
  },
  updateDashboard: ({ commit }, payload) => {
    service
      .updateVersion(payload)
      .then(response => {
        commit('updateDashboardVersionSuccess', response);
        commit(
          'showToast',
          {
            color: 'toast_default',
            text: 'CustomizePlugin.dashboardVersionSuccess',
          },
          {
            root: true,
          }
        );
        setTimeout(() => {
          location.reload();
        }, 1500);
      })
      .catch(() => {
        commit(
          'showToast',
          {
            color: 'toast_error',
            text: 'CustomizePlugin.setConfigFailed',
          },
          {
            root: true,
          }
        );
      });
  },
  syncShopifyContacts: ({ commit }) => {
    service
      .syncShopifyContacts()
      .then(() => {
        commit(
          'showToast',
          {
            color: 'toast_default',
            text: 'CustomizePlugin.syncSuccess',
          },
          {
            root: true,
          }
        );
      })
      .catch(() => {
        commit(
          'showToast',
          {
            color: 'toast_error',
            text: 'CustomizePlugin.setConfigFailed',
          },
          {
            root: true,
          }
        );
      });
  },
  updateSettings: ({ commit, state }, arg = null, noToast) => {
    return service.updateSettings(state, arg).then(response => {
      commit('updateSettingsSuccess', response);

      !noToast &&
        commit(
          'showToast',
          {
            color: 'toast_default',
            text: 'Email.successSaved',
          },
          {
            root: true,
          }
        );
    });
  },
  sendSignatureEmail: ({ commit, dispatch }, payload) => {
    service
      .sendSignatureEmail(payload)
      .then(() => {
        commit(
          'showToast',
          {
            color: 'toast_default',
            text: 'Email.sentSuccess',
          },
          {
            root: true,
          }
        );
        dispatch('loadAccountInfo', {}, { root: true });
        // setTimeout(() => {
        //   location.reload();
        // }, 1500);
      })
      .catch(() => {
        commit(
          'showToast',
          {
            color: 'toast_error',
            text: 'CustomizePlugin.setConfigFailed',
          },
          {
            root: true,
          }
        );
      });
  },
  verifySignatureEmail: ({ commit, dispatch }, payload) => {
    service
      .verifySignatureEmail(payload)
      .then(() => {
        commit(
          'showToast',
          {
            color: 'toast_default',
            text: 'Email.validating',
          },
          {
            root: true,
          }
        );
        dispatch('loadAccountInfo', {}, { root: true });
        // setTimeout(() => {
        //   location.reload();
        // }, 1500);
      })
      .catch(() => {
        commit(
          'showToast',
          {
            color: 'toast_error',
            text: 'CustomizePlugin.setConfigFailed',
          },
          {
            root: true,
          }
        );
      });
  },
  getWidgets: (_, themeId) => {
    return service.getWidgets(themeId);
  },
  installWidget: (_, { themeId, data }) => {
    return service.installWidget(themeId, data);
  },
  uninstallWidget: (_, { themeId, data }) => {
    return service.uninstallWidget(themeId, data);
  },
  installAllWidgets: (_, { themeId, data }) => {
    return service.installAllWidgets(themeId, data);
  },
  uninstallAllWidgets: (_, themeId) => {
    return service.uninstallAllWidgets(themeId);
  },
  updateAsset: (_, { themeId, data }) => {
    return service.updateAsset(themeId, data);
  },
  checkWidgetStatus: (_, themeId) => {
    return service.checkStatus(themeId);
  },
  getAssets: (_, themeId) => {
    return service.getAssets(themeId);
  },
  getAssetCode: (_, { themeId, asset }) => {
    return service.getAssetCode(themeId, asset);
  },
  getThemes: () => {
    return service.getThemes();
  },
};
